export enum PaymentProcessingStatus {
    None,
    Declined,
    Error,
    Success
}